exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\r\n#map {\r\n  height: 500px;\r\n  width:100%;\r\n}\r\n.incassiInLavorazione{\r\n  height: 3em;\r\n}\r\n@media(max-width:925px){\r\n  \r\n  #map {\r\n    width:auto;\r\n    width:initial;\r\n    margin-right:4em;\r\n  }\r\n}\r\n\r\n.bg-yellow{\r\n  background-color: #f3DD12 !important;\r\n}\r\n.inlineblock{\r\n  display:inline-block;\r\n}\r\n\r\n.mat-tab-body-content {\r\n  overflow: visible !important;\r\n}\r\n\r\n.mat-tab-body.mat-tab-body-active {\r\n  position: relative;\r\n  overflow-x:inherit;\r\n  overflow-x:initial;\r\n  overflow-y: visible;\r\n \r\n}\r\n.incassiInLavorazione {\r\n  width:3em;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/ETT/Progetti/JumpvNext/Angular/AgentiWebUI/AgentiWebConqordOil.Web.UI/src/app/components/clienti/clienti-list.component.css
// module id = ../../../../../src/app/components/clienti/clienti-list.component.css
// module chunks = main